import { StatBarWrapper, StatBarWrapperProps } from "./stat-bar-wrapper";
import { Stack, Text } from "@chakra-ui/react";

export interface StatBarErrorProps extends StatBarWrapperProps {
  message: string;
}

export const StatBarError = (props: StatBarErrorProps) => {
  const { message, ...rest } = props;

  return (
    <StatBarWrapper bg="#ff000080" {...rest}>
      <Stack align="center" justify="center" w="100%">
        <Text color="white">{message}</Text>
      </Stack>
    </StatBarWrapper>
  );
};
